import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`relative flex flex-wrap justify-center -m-2`};
  grid-template-columns: repeat(auto-fit, 4rem);
  --option-size: 3rem;
`

export const Option = styled.div`
  ${tw`relative block m-2`};
  min-width: var(--option-size);
  /* ${({ $isDisabled }) => $isDisabled && tw`opacity-50 cursor-not-allowed`}; */
`

export const OptionLabel = styled.label`
  ${tw`relative flex items-center justify-center px-3 text-center`};
  height: var(--option-size);
  color: var(--color-gold);
  cursor: pointer;
`

export const OptionInput = styled.input`
  ${tw`absolute block w-full h-full appearance-none rounded-none`};
  z-index: -1;
  border: 1px solid var(--color-gold);
  transition: color 0.2s, background-color 0.2s;

  &:checked {
    background-color: var(--color-gold);
  }

  &:checked ~ ${OptionLabel} {
    color: var(--color-white);
  }

  &[data-disabled='true'] {
    border-color: var(--color-grey-gold);
    background: linear-gradient(to top right, transparent calc(50% - 0.5px), #d8d8d8, transparent calc(50% + 0.5px));
  }

  &[data-disabled='true']:checked {
    background-color: var(--color-grey);
  }

  &[data-disabled='true'] ~ ${OptionLabel} {
    color: var(--color-grey-gold);
  }
`
